import { Action } from 'redux';

import { DiscardDraftRequested, DiscardDraftSucceeded, DiscardDraftFailed, RemoveDraftFromContentInfo } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { ExplorableItemType } from '../../ts/models/ContentType';


export interface DiscardDraftRequestedAction extends Action {
  draftLuid: string;
  contentType: ExplorableItemType;
  parentLuid: string;
  name?: string;
}

export interface DiscardDraftSucceededAction extends Action {
  draftLuid: string;
}

export interface DiscardDraftFailedAction extends Action {
  error: Error;
}

export interface RemoveDraftFromContentInfoAction extends Action {
  contentType: ExplorableItemType;
  contentId: string;
}

export function discardDraftRequestedAction(
  draftLuid: string,
  contentType: ExplorableItemType,
  parentLuid: string,
  name: string): DiscardDraftRequestedAction {
  return {
    type: DiscardDraftRequested,
    draftLuid,
    contentType,
    parentLuid,
    name
  };
}

export function discardDraftSucceededAction(draftLuid: string): DiscardDraftSucceededAction {
  return {
    type: DiscardDraftSucceeded,
    draftLuid
  };
}

export function discardDraftsFailed(e: Error): DiscardDraftFailedAction {
  return {
    type: DiscardDraftFailed,
    error: e,
  };
}

export function removeDraftFromContentInfo(contentId: string, contentType: ExplorableItemType): RemoveDraftFromContentInfoAction {
  return {
    type: RemoveDraftFromContentInfo,
    contentType,
    contentId
  };
}

export const isDiscardDraftSucceededAction = isActionFactory<DiscardDraftSucceededAction>(DiscardDraftSucceeded);
export const isRemoveDraftFromContentInfoAction = isActionFactory<RemoveDraftFromContentInfoAction>(RemoveDraftFromContentInfo);
